import { useEffect, useState, useCallback, useRef } from 'react';

const KONAMI_CODE = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'KeyB',
  'KeyA',
];

export function useKonamiCode(callback: () => void): boolean {
  const inputSequenceRef = useRef<string[]>([]);
  const [activated, setActivated] = useState(false);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      const key = event.code;

      // Update sequence using ref to avoid re-renders
      const newSequence = [...inputSequenceRef.current, key].slice(
        -KONAMI_CODE.length
      );
      inputSequenceRef.current = newSequence;

      // Check if sequence matches
      if (newSequence.length === KONAMI_CODE.length) {
        const isMatch = newSequence.every((k, i) => k === KONAMI_CODE[i]);
        if (isMatch && !activated) {
          setActivated(true);
          callback();
        }
      }
    },
    [callback, activated]
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  // Reset after a delay for reuse
  useEffect(() => {
    if (activated) {
      const timer = setTimeout(() => setActivated(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [activated]);

  return activated;
}
